import { SkillListItemsContext } from "@/context/SkillListItemsContext";
import React from "react";

export default function useSkillListItems() {
  return React.useContext(SkillListItemsContext);
}
